import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import FL from './directory/FL';
import Assessment from './Pre-Interview/assessment';
import NotFound from './directory/NotFound';

// Protected route component
const ProtectedRoute = ({ element }) => {
  const userData = sessionStorage.getItem('preAssessmentUserData');
  
  if (!userData) {
    return <Navigate to="/" replace />;
  }
  
  return element;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<FL />} />
      <Route path="/FL" element={<FL />} />
      
      
      
      <Route 
        path="/Pre-Interview/assessment" element={<ProtectedRoute element={<Assessment />} />} />

        
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;